module.exports = __webpack_public_path__ + "img/police-office-banner-2.cb580680.png";